import type { ReactNode } from 'react';
import styled from 'styled-components';

import type { Props as LoadMoreProps } from '@sorare/core/src/atoms/buttons/LoadMoreButton';
import { LoadMoreButton } from '@sorare/core/src/atoms/buttons/LoadMoreButton';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';

import { ResultCount } from '#src/components/mySorare/common/ResultCount/index.tsx';

type Props = {
  displayLoading?: boolean;
  count?: number;
  items?: Array<ReactNode | null> | null;
  loadMoreSection?: LoadMoreProps;
};

const Contents = styled(Vertical).attrs({ gap: 2 })`
  flex: 1;
`;
const LoadMore = styled.div`
  display: flex;
  justify-content: center;
`;

const Grid = styled(Horizontal).attrs({ gap: 2 })`
  flex-wrap: wrap;
  container-type: inline-size;
`;

export const DisplayItems = ({
  displayLoading,
  count,
  items,
  loadMoreSection,
}: Props) => {
  return (
    <>
      {displayLoading ? <LoadingIndicator /> : null}
      {count !== undefined ? <ResultCount count={count} /> : null}
      <Contents>
        <Grid>{items}</Grid>
        {!!loadMoreSection && (
          <LoadMore>
            <LoadMoreButton {...loadMoreSection} />
          </LoadMore>
        )}
      </Contents>
    </>
  );
};
